<div class="component-dialog-schedule">
    <span *ngIf="showHeaderError" class="error-load-schedule-setting">
      No hay agenda disponible para el día seleccionado.
    </span>
  
    <form class="cds-body" [formGroup]="formSchedule">
      <div class="cds-input-container">
        <mat-form-field class="cds-input" appearance="outline">
          <mat-label>Fecha</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            [min]="currentDate"
            [formControl]="formGroup.fieldDate"
            (dateChange)="onDateChange($event)"
            readonly
            required
          />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
  
        <mat-form-field class="cds-input" appearance="outline">
          <mat-label>Hora</mat-label>
          <mat-select [formControl]="formGroup.fieldHour" required>
            <mat-option *ngFor="let item of listHoursAndMinutes" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.fieldHour.invalid">
            Debes seleccionar la hora de agendamiento
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  
    <div class="cds-footer">
      <button mat-button class="cds-footer-btn" (click)="onClickClose()">Cancelar</button>
      <span class="cds-footer-divider"></span>
      <button mat-button color="primary" class="cds-footer-btn accept" (click)="onClickAccept()">Agendar</button>
    </div>
  </div>
  